import React from "react";
import { colors } from "../../../../themes/Colors";

const AgencyInfoCard = ({ right, display }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // height: 600,
        paddingTop: 40,
      }}
    >
      <div
        style={{
          //   height: "85%",
          width: "80%",
          maxWidth: 1200,
          borderWidth: 4,
          borderStyle: "solid",
          borderColor: colors.white,
          backgroundColor: colors.secondaryGrey,
          display: "flex",
          borderRadius: 40,
          WebkitBoxShadow: "-2px 20px 40px -10px #000000",
          //   marginLeft: right ? 0 : 100,
          //   marginRight: right ? 100 : 0,
        }}
      >
        {display}
      </div>
    </div>
  );
};

export default AgencyInfoCard;
